import FlexPane from './_flex-pane.js'
import PrebuiltBet from './_prebuilt-bet.js'
import Text from './_text.js'
import Swiper from './_swiper.js'
import LoaderSuspense from './_loader-suspense.js'
import PrebuiltBetsSkeleton from './_prebuilt-bets-skeleton.js'

export default {
  name: 'PrebuiltBets',
  values: {
    locationId: 'prebuilt_cards',
    showCarousel: true,
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          flexDirection: 'column',
        },
      },
    },
    carouselContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          _mobile_padding: '0px',
          maxWidth: '100%',
        },
      },
    },
    prebuiltBet: {
      configSet: PrebuiltBet,
      configValues: {},
    },
    carouselTitle: {
      configSet: Text,
      configValues: {
        container: {
          display: 'flex',
          height: '40px',
          flexWrap: 'wrap',
          alignItems: 'center',
          padding: '0 0 0 8px',
        },
      },
    },
    swiper: {
      configSet: Swiper,
      configValues: {
        lazyLoadBufferSize: 1,
        minViewableBufferSize: 3,
        _mobile_minViewableBufferSize: 2,
        style: {
          gap: '8px',
          _mobile_padding: '0 8px',
          scrollPaddingLeft: '8px',
          scrollPaddingRight: '8px',
        },
        slide: {
          style: {
            width: '294px',
            flexBasis: '294px',
          },
        },
      },
    },
    minBetsForEnablingArrowNav: 4,
    betsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          overflow: 'hidden',
          flexWrap: 'wrap',
          _mobile_padding: '8px',
          _mobile_justifyContent: 'center',
        },
      },
    },
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        style: {
          container: {
            maxWidth: '100%',
          },
          hidden: {
            display: 'block',
            width: '100%',
            position: 'absolute',
            visibility: 'hidden',
            opacity: 0,
            zIndex: -1,
          },
        },
      },
    },
    prebuiltBetsSkeleton: {
      configSet: PrebuiltBetsSkeleton,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
